import {forwardRef, HTMLAttributes} from 'react';

const TableStaticColumnBody = forwardRef<
    HTMLTableSectionElement,
    HTMLAttributes<HTMLTableSectionElement>
>(({children, ...props}, ref) => (
    <tbody ref={ref} {...props}>
        {children}
    </tbody>
));

TableStaticColumnBody.displayName = 'TableStaticColumnBody';

export default TableStaticColumnBody;
